// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"47":"560c2aed","800":"ad5afda4","864":"7240e6e0"}[chunkId] + ".js";
};